/** Teto de avisos por janela. O histórico antigo vem com "Carregar mensagens anteriores". */
export const CHAT_ACTIVITY_WINDOW_LIMIT = 100;

export type ActivityWindow = {
  /** Inclusivo: avisos a partir da mensagem mais antiga já carregada. */
  since?: string | null;
  /** Exclusivo: ao subir a página, não repete avisos que já estão na tela. */
  until?: string | null;
};

export function mergeActivityLogs<T extends { id: string; created_at: string }>(
  current: readonly T[],
  incoming: readonly T[],
): T[] {
  if (incoming.length === 0) return current as T[];
  const byId = new Map<string, T>();
  for (const row of current) byId.set(row.id, row);
  for (const row of incoming) byId.set(row.id, row);
  return [...byId.values()].sort((a, b) => a.created_at.localeCompare(b.created_at));
}

/** O canal ligado já entrega a mensagem. A busca fica para quando ele caiu. */
export function shouldRefetchChatOnFocus(channelHealthy: boolean): boolean {
  return !channelHealthy;
}
